import Vue from 'vue';
import moment from 'moment-timezone';
import VTooltip from 'v-tooltip';
import { Timeline } from 'vue2vis';
import Multiselect from 'vue-multiselect';
import DatePicker from 'vue2-datepicker';

import dateSwitch from '@/components/dateSwitch/index.vue';
import search from '@/components/search/index.vue';
import tooltipStatus from '@/components/tooltipStatus/index.vue';
import preloader from '@/components/preloader/index.vue';
import pagination from '@/components/paginationSimple/index.vue';
import empty from '@/components/emptyContainer/index.vue';

import helpers from '@/mixins/helpers';

import Api from '@/utils/api';

Vue.use(VTooltip, {
  defaultBoundariesElement: document.body,
});

Vue.use(Timeline);

export default {
  mixins: [
    helpers.sort_table_default,
  ],
  components: {
    dateSwitch,
    Multiselect,
    DatePicker,
    tooltipStatus,
    Timeline,
    preloader,
    pagination,
    search,
    empty,
  },
  data () {
    return {
      jobs: [],
      responseData: [],
      reportsDataTotal: null,

      searchText: '',
      dateFilterSwitch: [],

      items: [],
      groups: [],

      filterParams: {
        name: 'jobs?',
        url: '',
      },

      pagination: {
        page: 1,
        ppage: 12,
      },

      load: true,
      search: false,
      refreshPagination: false,
    };
  },
  watch: {
    pagination: {
      deep: true,
      handler() {
        this.getFiltersJobs();
      },
    },
    dateFilterSwitch() {
      this.setFilters();
    },
    search() {
      this.setFilters();
    },
  },
  computed: {
    countPage () {
      return this.responseData.Total < this.pagination.ppage ? this.responseData.Total : this.pagination.ppage;
    },
    options () {
      return {
        editable: false,
        zoomable: false,
        zoomMax: 31536000000,
        zoomMin: 115360000,
        orientation: 'top',
        timeAxis: { scale: 'week' },
        width: '100%',
        showCurrentTime: true,
        height: `${this.items.length * 50 + 65}px`,
      };
    },
  },
  created () {
    this.$store.dispatch('SHOW_PRELOADER', false);
  },
  mounted () {
    setTimeout(() => {
      window.scroll({ top: 0, left: 0, behavior: 'smooth' });
    }, 1000);
    this.getFiltersJobs();
  },
  methods: {
    dateSwitchJob (item) {
      this.dateFilterSwitch = item.value;
    },

    holderSearch (searchString) {
      this.pagination.page = 1;
      this.load = true;
      this.search = searchString;
      this.getSearchJobs();
    },

    setFilters () {
      this.filterParams.url = [['qstr', this.search], ['created_on', this.dateFilterSwitch]]
        .filter((i) => Array.isArray(i[1]) ? i[1].some((ii) => !!ii) : !!i[1])
        .map((el) => Array.isArray(el[1]) ? `${el[0]}=${el[1].join(',')}` : `${el[0]}=${el[1]}`).join('&');
      this.getFiltersJobs();
    },

    /**
         * Method for reset search text
         */
    resetSearch () {
      this.search = '';
    },

    getSearchJobs () {
      Api.search('jobs', this.search, { page: this.pagination.page, perPage: this.pagination.ppage })
        .then((data) => {
          this.holderResponse(data);
        });
    },

    getFiltersJobs () {
      this.load = true;

      Api.filters
        .sendFilters(this.filterParams, { page: this.pagination.page, perPage: this.pagination.ppage })
        .then((data) => {
          this.holderResponse(data);
        });
    },

    sortingTable () {
      this.getFiltersJobs();
    },

    holderResponse (data) {
      this.items = [];
      this.groups = [];
      this.jobs = [];
      this.responseData = [];
      this.reportsDataTotal = null;

      if (data.data.Status) {
        this.items = [];
        this.groups = [];

        this.jobs = data.data.Data;
        this.responseData = data.data;
        this.reportsDataTotal = data.data.Total;

        this.jobs.forEach((item, index) => {
          this.groups.push({ id: index, content: 'q' });

          const nameItem = item.Name + ' | ' +
                        item.SourceLanguage.CountryISOCode + '-' +
                        item.SourceLanguage.CountryISOCode + ' >> ' +
                        item.TargetLanguage.CountryISOCode + '-' +
                        item.TargetLanguage.CountryISOCode + ' | ' +
                        item.JobTypeData.Name + ' | ' +
                        item.ClientData;

          this.items.push({
            id: item.ID,
            group: index,
            title: this.setTooltipTemplate(item),
            content: nameItem,
            start: new Date(item.CreationDate * 1000),
            end: new Date(item.DatetimeEnd * 1000),
            style: this.setColorJobs(item),
          });
        });
      }

      this.load = false;
    },

    setColorJobs (item) {
      let styles;

      if (item.JobTypeData.Name == 'Validation') {
        styles = 'border: 1px solid #00ACE6; background: rgba(219, 236, 242, 0.9); color: #00ACE6';
      } else if (item.JobTypeData.Name == 'Evaluation') {
        styles = 'border: 1px solid #B2B212; background: rgba(239, 239, 229, 0.9); color: #B2B212';
      } else if (item.JobTypeData.Name == 'Preparation') {
        styles = 'border: 1px solid #5f5f5f; background: rgba(221, 236, 228, 0.9); color: #5f5f5f;';
      }

      return styles;
    },

    setTooltipTemplate (item) {
      const template = '<div class="timeline-tooltip">' +
                '<div class="timeline-tooltip-header">' +
                    '<span class="timeline-tooltip-circle"></span>' +
                    '<div class="timeline-tooltip-status">' +
                        item.JobTypeData.Name +
                    '</div>' +
                    '<span>&nbsp;|&nbsp;</span>' +
                    '<div class="timeline-tooltip-accept">' +
                        item.JobTypeData.BtnText +
                    '</div>' +
                '</div>' +
                '<div class="timeline-tooltip-content">' +
                    '<div class="timeline-tooltip-content-row">' +
                        '<span>Start date</span>' +
                        '<span>' + moment.unix(item.CreationDate).format('DD.MM.YYYY') + '</span>' +
                    '</div>' +
                    '<div class="timeline-tooltip-content-row">' +
                        '<span>Deadline</span>' +
                        '<span>' + moment.unix(item.DatetimeEnd).format('DD.MM.YYYY') + '</span>' +
                    '</div>' +
                '</div>' +
            '</div>';

      return template;
    },

    routeToJob (el) {
      this.$router.push(`/jobs/detail/${el.items}`);
    },

    selectDataView () {
      return this.$route.params.view ? this.$route.params.view : 'timeline';
    },
  },
};
